import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

import Glyph from 'component/utils/Glyph'


const Table = ({
  cdMissionList,
  openModal,
  records,
  setCdMissionList,
  translate,
  removeSelected
}) => {
  const tableRef = useRef(null)
  const [height,setHeight] = useState(0)
  // Pagination below table
  const PAGINATION_HEIGHT = 71
  // Search and Filter
  const TOP_ACTIONS = 95
  // TOOLBAR + Title
  const TOP_BAR = 67 + 50


  useEffect(() => {
    setHeight(window.innerHeight)
    const calculateHeight = () => {
      setHeight(window.innerHeight)}
    window.addEventListener("resize", calculateHeight)
    return () => window.removeEventListener("resize", calculateHeight)
  }, [])

  useEffect(() => {

    if(height < 868 && height !== 0) {
      const responsiveHeight = height - (PAGINATION_HEIGHT + TOP_ACTIONS + TOP_BAR + 100)
      const tbody = document.querySelector('.tbody-mission-block')
      tbody.style.maxHeight = `${responsiveHeight}px`
    }
    else {
      const tbody = document.querySelector('.tbody-mission-block')
      tbody.style.maxHeight = `500px`
    }
  }, [height])
  const renderHeader = () => {

    let checked = false
    let setAll = true
    let checkedClassName = "stock-transfer-checkbox"
    const cdMissionListLength = cdMissionList.length

    if (cdMissionListLength) {
      if (cdMissionListLength < records.length) {


        checked = true
        checkedClassName = "stock-transfer-checked-mid"
      } else {
        checked = true

        setAll = false
      }
    }

    useEffect(() => {

    }, [records])

    return (
      <tr>
        <th
          onClick={() =>
            setCdMissionList(setAll ? records.map((i) => i.cdMission) : [])
          }
          className='text-align-center'
        >

          <input checked={checked} type={"checkbox"} className={checkedClassName} />

        </th>
        <th>{translate('stockTransfer.missionBlock.table.header.mission')}</th>
        <th>{translate('stockTransfer.missionBlock.source')}</th>
        <th>{translate('stockTransfer.missionBlock.destination')}</th>
        <th style={{display: cdMissionListLength > 0 ? 'none' : ''}} className='text-align-center'>{translate('edit_button_label')}</th>
      </tr>
    )
  }

  const renderBody = () => {


    const renderDepositList = (list) => {
      if (!list.length) return 'Sem permissão'

      return list.map((deposit) => deposit.idDeposit).join(', ')
    }

    const renderRecord = (record) => {
      const { cdMission } = record

      const checked = cdMissionList.some((item) => item === cdMission)

      return (
        <tr className={`${checked ? 'stock-transfer-checked' : ''}`} key={cdMission}>
          <td
            onClick={() =>
              {
              checked && removeSelected(cdMission)
              setCdMissionList(
                checked
                  ? cdMissionList.filter((i) => i !== cdMission)
                  : [...cdMissionList, cdMission]
              )
              }
            }
            className='text-align-center'
          >
            <input type={"checkbox"} className="stock-transfer-checkbox" value={checked} checked={checked} />
          </td>
          <td>{record.dsMission}</td>
          <td>{renderDepositList(record.sourceDepositList)}</td>
          <td>{renderDepositList(record.destinationDepositList)}</td>
          <td style={{display: cdMissionList.length > 0 ? 'none' : ''}} className='mission-block-edit-icon'>
            <Glyph
              type='pencil'
              color='primary'
              onClick={() => openModal(record)}
            />
          </td>
        </tr>
      )
    }

    return records.map(renderRecord)
  }

  return (
    <table  cellPadding={0} cellSpacing={0} className='mission-block-table-new new'>
      <thead ref={tableRef}>{renderHeader()}</thead>
      <tbody className='tbody-mission-block'  onScroll={(e) => {
        if(e.currentTarget.scrollTop > 20) {
          tableRef.current.classList.add("shadow-table-header-mission-block")
        }
        else {
          tableRef.current.classList.remove("shadow-table-header-mission-block")
        }
      }} >{renderBody()}</tbody>
    </table>
  )
}

Table.propTypes = {
  cdMissionList: PropTypes.array.isRequired,
  handleResize: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  records: PropTypes.array.isRequired,
  setCdMissionList: PropTypes.func.isRequired,
  size: PropTypes.number.isRequired,
  translate: PropTypes.func.isRequired,
  removeSelected: PropTypes.func.isRequired
}

export default Table
